exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/", ""]);

// exports
